import React from 'react';
import { SkeletonText } from '@/components/skeleton-text';
import { StyleSheet, View } from 'react-native';

export const CatalogSidebarLoading: React.FC = () => {
  return (
    <View style={styles.sidebar}>
      <SkeletonText />
      <SkeletonText width="80%" />
      <SkeletonText width="60%" />
    </View>
  );
};

const styles = StyleSheet.create({
  sidebar: {
    marginTop: 20,
    width: 196,
  },
});
